/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import {View, Platform} from 'react-native';
import { InputField } from '../../components/Inputs/InputField';
import { AccountServices } from '../../../services/applicatif/account';
import styles from './styles';
import { Loader } from '../../components/Loader';
import { connect } from 'react-redux';
import mapDispatchToProps from '../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../services/redux/mapStateToProps';
import config from '../../../data/config';
import { CheckBoxWithHyperlink } from '../../components/CheckBoxWithHyperlink';
import Label from '../../components/Label';
import { buttonsStyles } from '../../components/Button/boutonStyle';
import PrimaryButton from '../../components/Button/PrimaryButton';
import ModalFC from '../../components/Modal/Modal/Modal';


interface DeleteAccountProps {
  onClose: () => void;
  logout: () => void;
  user: any;
}
export const DeleteAccountFC = ({user, onClose, logout}: DeleteAccountProps) => {

  const [deleteModalScreen, setDeleteModalScreen] = React.useState<'agreement' | 'validation'>('agreement');
  const [password, setPassword] = React.useState<string>('');
  const [motif, setMotif] = React.useState<string>('');
  const [acceptDelete, setAcceptDelete] = React.useState<boolean>(false);
  const [modalLoading, setModalLoading] = React.useState<boolean>(false);
  const [errorMessage, setErrorMessage] = React.useState<string>('');
  const userId: string = user?.data?.utilisateur?.id || ''

  return (
    <ModalFC title="Suppression de compte" style={deleteModalScreen === 'agreement' ? {justifyContent: 'flex-start', alignItems: 'baseline'} : {}}>
      {deleteModalScreen === 'agreement' ? <>
        <Label title= 'Êtes-vous certain de vouloir Supprimer votre compte ?' />
        <InputField
          label={'Motif de suppression'}
          required
          type="text"
          value={motif}
          name="motif"
          onChange={(name: string, value: string) => setMotif(value)}
          maxLength={50}
          onSubmitEditing={() => null}
          style={{ width: '100%' }}
        />
        <CheckBoxWithHyperlink 
          style={{flex: 0}}
          checked={acceptDelete}
          setChecked={setAcceptDelete}
          text={`En cochant cette case, j'accepte de supprimer définitivement mon compte ainsi que \nles informations mentionées dans la ${Platform.OS === 'web' ? '' : config.privacyURL}`} 
        />
      </> : <View style={{minWidth: 80}}>
        {errorMessage ? <Label type='error' title={errorMessage} /> : null}
        <View style={{height: 20}} />
        <InputField
          label={'Veuillez entrer votre mot de passe'}
          required
          type="password"
          value={password}
          name="password"
          onChange={(name: string, value: string) => setPassword(value)}
          maxLength={50}
          onSubmitEditing={() => null}
        />
      </View>}
      <View style={styles.btnContainerProfilP}>
        {modalLoading ? <Loader /> : <>
          <PrimaryButton
            onPress={() => {
              onClose()
            }}
            styleBtnTxt={buttonsStyles.btnAnnuler}
            styleBtnOuter={buttonsStyles.btnAnnulerOuter}
            title="Annuler"
            type="annuler"
          />
          <PrimaryButton
            onPress={async () => {
              if (deleteModalScreen === 'agreement') {
                setDeleteModalScreen('validation')
              } else {
                setModalLoading(true);
                AccountServices().removeAccount(userId, password, motif)
                .then((res: any) => {
                  setModalLoading(false);
                  if (res.isError) {
                    setErrorMessage(res?.message || '')
                  } else {
                    onClose();
                    logout()
                  }
                })
                .catch((error: any) => console.log('error', error));
              }
            }}
            isDisable={deleteModalScreen === 'agreement' ? !acceptDelete || !motif : !password}
            styleBtnTxt={buttonsStyles.btnValider}
            styleBtnOuter={buttonsStyles.btnValiderOuter}
            title={deleteModalScreen === 'agreement' ? "J'accepte" : "Valider"}
            type="valider"
          />
        </>}
      </View>
    </ModalFC>
    )
}
export const DeleteAccount: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DeleteAccountFC);
